import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';


import TimelineInnerNavi from '../timelineInnerNavi';
import Iconset from '../icons';

import '../../styles/chapter3/chapter_three_timeline.scss';


class Timeline extends React.Component{

	constructor(props){
		super(props);

	}
	
	togglePlay(){
		this.playButton.blur();
		if(this.props.isPlaying){
			this.props.pause();
		}else{
			this.props.play();
		}
	}

	goToOutro(){
		browserHistory.push(_assets.root + '/outro');
	}


	render(){
		
		let publicChapter = this.props.currentInnerChapter ;
			
		var timelineStyles = {}
		
			//intro
			if(this.props.currentInnerChapter==1){
				timelineStyles = {
					width : 10 + (this.props.currentVideoTimePercentage *.1) + "%"
				}
			}

			if(this.props.currentInnerChapter==2){
				timelineStyles = {
					width : 20 + (this.props.currentVideoTimePercentage *.8) + "%"
				}
			}
		

		return (
			<div className="flex-box timeline-holder">
				<div className="timeline-inner">
					<button ref={(playButton)=>{this.playButton = playButton}}className={"play-button isPlaying-"+ this.props.isPlaying} onClick={()=>this.togglePlay()}>
						{ this.props.isPlaying && 
								<Iconset.pause/>
							}{ !this.props.isPlaying && 
									<Iconset.play/>
								}</button>
					<TimelineInnerNavi />
					<div className={"timeline-track timeline-track-intro-animation-" + this.props.currentInnerChapter + " generatorIsActive-"+this.props.generatorIsActive}>
						<div className="timeline-track-slider" style={timelineStyles}></div>
						<div className={"timeline-track-marker-holder active-marker-" + publicChapter}>
							
							<div className={"timeline-track-marker-triangle generator-icon"}></div>
						
							<button className="timeline-track-marker marker-2-1" data-name="0" onClick={()=>this.props.goToInnerChapter(0)}>
								<span className="tool-tip" data-name="0">#intro</span>
							</button>
							<button className="timeline-track-marker marker-2-2" data-name="1" onClick={()=>this.props.goToInnerChapter(2)}>
								<span className="tool-tip" data-name="1">#tracklist</span>
							</button>
							
							<button className="timeline-track-marker marker-2-8" data-name="3" onClick={this.goToOutro}>
								<span className="tool-tip" data-name="3">#outro</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			)
	}

}


export default Timeline;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/chapter_three_timeline.js